var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 73,
    viewBox: "0 0 107 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4838 45.2681C32.3208 43.8011 30.1146 42.0557 29.1654 41.2466C27.4561 39.7895 25.6085 38.9172 23.4987 38.4484C22.5744 38.243 21.406 38.4343 20.4614 38.4343C18.8408 38.4343 17.0971 38.2153 15.5259 38.6312C12.8727 39.3335 10.5971 40.6477 8.43901 42.3434C7.16085 43.3476 6.02313 44.0742 4.89556 45.2681C4.11075 46.0991 3.95972 47.2849 3.26445 48.1788C2.77756 48.8048 2.36453 50.9575 2.36453 51.7363C2.36453 53.7716 1.7343 56.5685 2.56139 58.4295C2.7582 58.8723 2.49866 59.3796 2.74418 59.8216C2.96087 60.2116 3.3294 61.0388 3.37694 61.4667C3.50902 62.6554 4.67593 63.82 5.14867 64.8836C5.92573 66.632 9.34527 68.7079 11.2231 68.8067C12.5454 68.8763 13.7731 69.3129 15.1463 69.3129C16.3883 69.3129 17.6304 69.3129 18.8725 69.3129C21.0887 69.3129 24.0186 67.8162 26.0156 66.9085C27.9681 66.021 29.3255 64.0994 30.2621 62.226C31.4513 59.8477 32.621 57.4358 32.976 54.7735C33.2366 52.8189 33.5293 50.8521 33.9462 48.9241C34.3398 47.1039 33.8755 45.1434 34.2696 43.3698C34.5448 42.1317 34.291 39.6271 34.291 38.314C34.291 35.4899 34.5087 36.8714 34.5087 38.6874C34.5087 40.7641 34.9619 42.8086 35.0149 44.8744C35.0753 47.2329 35.0149 49.6019 35.0149 51.9613C35.0149 58.1965 34.0025 64.3694 34.0025 70.5785",
    stroke: "#FF630B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7578 2.30133C91.2399 7.60393 91.525 13.0943 91.525 18.4117C91.525 24.909 91.8164 31.519 91.255 37.9742C90.3025 48.928 91.2693 59.6403 91.2693 70.5784",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6934 37.3349C79.0072 37.3349 81.4545 37.4436 83.6546 36.7667C85.841 36.0939 88.8271 36.5678 91.1273 36.5678C93.6551 36.5678 96.1315 36.312 98.6852 36.312C100.699 36.312 102.554 36.5678 104.567 36.5678",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/AT.122e8ed47a6f7a99130d22fe5c0187c1.svg";
export { ForwardRef as ReactComponent };